/** 导出文件名时间后缀：年月日_时分秒（避免 / 被浏览器替换成 _） */
export const getExportFileTimeSuffix = (date: Date = new Date()) => {
  const pad = (n: number) => String(n).padStart(2, '0');
  return [
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
    pad(date.getHours()),
    pad(date.getMinutes()),
    pad(date.getSeconds()),
  ].join('_');
};

export const ORDER_LIST_EXPORT_FILE_BASE = '订单信息表';
export const ORDER_BOM_EXPORT_FILE_BASE = '订单Bom比对数据表';

export const buildOrderListExportFileName = (date?: Date) =>
  `${ORDER_LIST_EXPORT_FILE_BASE}_${getExportFileTimeSuffix(date)}.xlsx`;

export const buildOrderBomExportFileName = (date?: Date) =>
  `${ORDER_BOM_EXPORT_FILE_BASE}_${getExportFileTimeSuffix(date)}.xlsx`;
